import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultConfig: DatePivotParams = {
  // dateHierarchy is inert here (no DatePeriodPicker, dateHierarchyColumnFilter
  // is null) — Container Mapping shows a single PO cycle, no date range.
  dateHierarchy: "order_placed_date",
  measure: "",
  // Default to SKU grain: one row per (container, SKU) and the units/pallet
  // column shown. Deselecting "SKU" collapses to container-only grain and drops
  // units/pallet (the transform only emits it at SKU grain).
  segments: ["sku"],
  minDate: null,
  maxDate: null,
  filters: [],
  postFilters: [],
};
